import type { Image } from "bildebanken-model";
import { copyNtbImageToMimir } from "services/ntb";
import { showEdit, type ImageSource } from "state/page";
import { updateMetadata } from "services/api";
import { getRequiredFields } from "services/plugin-customization";
import { publishAndSelect, publishAndSelectNtb } from "components/Plugin/publishAndSelect";
import { glassPaneState } from "components/Plugin/GlassPane";
import {
  fieldMissingInImage,
  type EditableMetadataFieldKey,
} from "components/Editor/editImageMachine";

function fulfillRequirements(image: Image | undefined): boolean {
  let requirementsFulfilled = true;
  getRequiredFields()?.forEach((requiredField) => {
    if (image && fieldMissingInImage(image, requiredField as EditableMetadataFieldKey)) {
      requirementsFulfilled = false;
    }
  });
  return requirementsFulfilled;
}

async function editNtbImage(
  itemId: string,
  altText: string | undefined,
  options: { selectImageAfterEdit: boolean } = { selectImageAfterEdit: false },
): Promise<void> {
  glassPaneState.set({ state: "VISIBLE", message: "Kopierer bilde til Bildebanken..." });
  const copiedItemId = await copyNtbImageToMimir(itemId, altText);
  glassPaneState.set({ state: "HIDDEN" });

  if (copiedItemId.id) {
    await showEdit([copiedItemId.id], options);
  } else {
    glassPaneState.set({
      state: "VISIBLE",
      message: "Kopiering til Bildebanken feilet, vennligst prøv igjen.",
    });
  }
}

export async function selectImageAction(params: {
  itemId: string;
  itemSource: ImageSource;
  image: Image | undefined;
  altText: string | undefined;
}): Promise<void> {
  const { itemId, itemSource, image, altText } = params;
  const requiredFields = getRequiredFields();
  const altTextRequired = requiredFields && requiredFields.includes("altText");

  if (!fulfillRequirements(image)) {
    if (itemSource === "Ntb") {
      if (altTextRequired && altText?.trim()) {
        await publishAndSelectNtb(itemId, altText);
      } else {
        await editNtbImage(itemId, altText, { selectImageAfterEdit: true });
      }
    } else {
      if (image && altText !== undefined) {
        await updateMetadata({ metadataDelta: { altText }, id: image.id });
      }
      await showEdit([itemId], { selectImageAfterEdit: true });
    }
  } else if (image && itemSource !== "Ntb") {
    await updateMetadata({ metadataDelta: { altText }, id: image.id });
    await publishAndSelect(image);
  } else if (itemSource === "Ntb") {
    await publishAndSelectNtb(itemId, altText);
  } else {
    console.warn("No image to select..", image);
  }
}
